export default __webpack_public_path__ + "static/kids-e7a4756e27ceb585ec56af2b496e79e1.jpg";